import React from 'react';
import './Footer.css'; // CSS pour le Footer
import { FaFacebookSquare, FaInstagram } from 'react-icons/fa'; // Assurez-vous que react-icons est bien installé

// Accepter showInstallButton et onInstallClick comme props
function Footer({ showInstallButton, onInstallClick }) { 
  const currentYear = new Date().getFullYear();

  // Fonction pour gérer le smooth scroll
  const handleSmoothScroll = (event, targetId) => {
    event.preventDefault(); // Empêche le comportement de saut par défaut
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: 'smooth', // Rend le défilement fluide
        block: 'start',      // Aligne le haut de l'élément avec le haut de la zone de défilement
      });
    }
  };

  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-content-wrapper">

          {/* Colonne 1: Infos / Social */}
          <div className="footer-column about-column">
            <h4 className="footer-column-title">Fromagerie Chez Paul</h4>
            <p>Votre artisan fromager passionné à L'Isle-Jourdain.</p>
            <div className="social-links">
              <a href="https://www.facebook.com/profile.php?id=61556009456859&mibextid=wwXIfr&rdid=iiVGoTdrEsgGHEeX&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F15neqbWN2B%2F%3Fmibextid%3DwwXIfr#" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <FaFacebookSquare />
              </a>
              <a href="https://www.instagram.com/fromagerie_chez_paul/?hl=fr" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <FaInstagram />
              </a>
            </div>
          </div>

          {/* Colonne 2: Liens rapides */}
          <div className="footer-column links-column">
            <h4 className="footer-column-title">Navigation</h4>
            <ul className="footer-links-list">
              {/* Utilisation de onClick pour le smooth scroll */}
              <li><a href="#hero" onClick={(e) => handleSmoothScroll(e, 'hero')}>Accueil</a></li>
              <li><a href="#about" onClick={(e) => handleSmoothScroll(e, 'about')}>Qui sommes-nous</a></li>
              <li><a href="#products" onClick={(e) => handleSmoothScroll(e, 'products')}>Nos Fromages</a></li> {/* #products doit correspondre à l'ID de votre section FeaturedProducts */}
              <li><a href="#gallery" onClick={(e) => handleSmoothScroll(e, 'gallery')}>Galerie</a></li>
              <li><a href="#location" onClick={(e) => handleSmoothScroll(e, 'location')}>Nous trouver & Horaires</a></li>
              {/* Assurez-vous que #contact et #gallery existent réellement dans votre App.js */}
              <li><a href="#contact" onClick={(e) => handleSmoothScroll(e, 'contact')}>Contact</a></li> 
            </ul>
          </div>

          {/* Colonne 3: Contact / Horaires (Optionnel) */}
          <div className="footer-column contact-column">
            <h4 className="footer-column-title">Contact Rapide</h4>
            <p>14 Place Gambetta<br/>32600 L'Isle-Jourdain</p>
            <p>Tél : <a href="tel:0562631960">05 62 63 19 60</a></p>
          </div>

        </div>

        {/* Bouton d'installation PWA */}
        {showInstallButton && (
          <div style={{ textAlign: 'center', marginBottom: '20px' }}>
            <button className="install-btn" onClick={onInstallClick}>
              📲 Installer l'application
            </button>
          </div>
        )}

        {/* Barre inférieure avec le Copyright */}
        <div className="footer-bottom-bar">
          <p>&copy; {currentYear} Fromagerie Chez Paul. Tous droits réservés.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;